import { createContext, useContext } from 'react';

export type ThemeModeContextType = {
  mode: 'light' | 'dark';
  toggleTheme: () => void;
};

export const ThemeModeContext = createContext<ThemeModeContextType | null>(null);

export const useThemeMode = () => {
  const context = useContext(ThemeModeContext);
  if (!context) {
    throw new Error('useThemeMode must be used within ThemeModeContext.Provider');
  }
  return context;
};
